import React, { useEffect, useState } from 'react'
import PostView from 'components/shared/PostView';
import { Link } from 'react-router-dom';
import Skeleton from 'components/shared/Skeleton';
import styles from 'modules/playlists/components/Playlist/Playlist.module.scss'
import useGetIndexByQuery from 'sdk/hooks/search/useGetIndexByQuery';
import SearchBlock from './SerachBlock';

type Props = {
  search: string,
  selectedCategory?: string,
  title?: string,
  setNotFound?: (state: boolean) => void,
}

export default function Videos({
  search, selectedCategory, title, setNotFound,
}: Props) {
  const [activePostId, setActivePostId] = useState('')
  const {
    mutate: getIndex,
    isLoading: loading,
    data,
  } = useGetIndexByQuery()

  useEffect(() => {
    if (search !== undefined) {
      getIndex({
        query: search, index: 'posts', category: selectedCategory === 'All' ? '' : selectedCategory,
      })
    }
  }, [search, selectedCategory])

  useEffect(() => {
    if (setNotFound) {
      if (!loading && !data?.length) {
        setNotFound(true)
      } else {
        setNotFound(false)
      }
    }
  }, [loading, data?.length])

  // @ts-ignore
  if (loading && !data?.length) {
    return (
      <SearchBlock title={title}>
        <div className={styles.playlistPosts}>
          {Array.from(Array(12).keys()).map((item: number) => (
            <div className={styles.playlistItem} key={item}>
              <Skeleton className={styles.playlistItemSkeleton} />
            </div>
          ))}
        </div>
      </SearchBlock>
    )
  }

  if (!data?.length) {
    return null
  }

  return (
    <SearchBlock title={title} className={loading ? 'blockLoading' : ''}>
      <div className={styles.playlistPosts}>
        {data?.map((item: any, index) => (
          <Link
            key={item?.objectID}
            to={`/search/feed/${item?.objectID}`}
            state={{ ids: data?.map((el) => el.objectID), active: index }}
            className={styles.playlistItem}
            onMouseEnter={() => setActivePostId(item?.objectID)}
            onMouseLeave={() => setActivePostId('')}
          >
            <PostView
              key={item?.objectID}
              data={{ data: item.details }}
              size={4}
              gridItemSize="small"
              grid
              style={null}
              isActive={item?.objectID === activePostId}
              className={styles.postItem}
            />
          </Link>
        ))}
      </div>
    </SearchBlock>
  )
}
